import { render, staticRenderFns } from "./MuvekkilDetayView.vue?vue&type=template&id=c06d37ce"
import script from "./MuvekkilDetayView.vue?vue&type=script&lang=ts"
export * from "./MuvekkilDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports